import { useState, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

const STORAGE_KEY = 'lyri_setlists'

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveToStorage(setlists) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(setlists))
}

function useSetlists() {
  const [setlists, setSetlists] = useState(loadFromStorage)

  useEffect(() => {
    saveToStorage(setlists)
  }, [setlists])

  function saveSetlist(setlist) {
    const now = Date.now()
    setSetlists(prev => {
      const existing = prev.find(s => s.id === setlist.id)
      if (existing) {
        return prev.map(s =>
          s.id === setlist.id
            ? { ...setlist, updatedAt: now }
            : s
        )
      }
      return [...prev, { ...setlist, id: uuidv4(), createdAt: now, updatedAt: now }]
    })
  }

  function deleteSetlist(id) {
    setSetlists(prev => prev.filter(s => s.id !== id))
  }

  return { setlists, saveSetlist, deleteSetlist }
}

export default useSetlists
